import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import { Topic } from '../components/topic/topic';
import { TopicProvider } from '../components/topic/context';

// Topic provider does the look up of data, we just pass it in required id's
const TopicTemplate = (props) => {
  return (
    <Layout>
      <TopicProvider data={props.data}>
        <Topic />
      </TopicProvider>
    </Layout>
  );
};

export default TopicTemplate;

export const query = graphql`
  query TopicTemplate($id: String!, $strapiId: ID!) {
    strapiTopic(uid: { eq: $id }) {
      id
      uid
      topic_description
      topic_name
      topic_url
      topic_seo_keywords
      topic_seo_meta_description
      topic_seo_title_tag
      topic_videos {
        videos {
          id
          uid
          video_name
          youtube_id
          topic {
            topic_url
          }
        }
      }
    }
    allStrapiTopic {
      edges {
        node {
          topic_name
          topic_description
          id
          uid
          topic_url
        }
      }
    }
    allStrapiArticle {
      edges {
        node {
          article_name
          article_url
          id
          uid
          topic {
            id
            topic_url
          }
          sub_topic {
            sub_topic_name
            sub_topic_order
            id
          }
        }
      }
    }
    supportcenter {
      getSupportData(input: { topicId: $strapiId }) {
        videos
        topics
        groupedArticles {
          subTopicName
          subTopicId
          subTopicOrder
          articles
        }
      }
    }
  }
`;
